import React from 'react';

export default function PrivacyPolicyPage() {
  return (
    <div className="max-w-4xl mx-auto p-8 text-gray-800 leading-7">
      <h1 className="text-3xl font-bold mb-6">Política de privacidad</h1>

      <p className="mb-4">
        En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y de la Ley Orgánica 3/2018 (LOPDGDD), se informa a las personas usuarias de este sitio web sobre el tratamiento de sus datos personales.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Responsable del tratamiento</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li><strong>Responsable:</strong> 77 SUAN XI S.L.</li>
        <li><strong>CIF:</strong> B-13924379</li>
        <li><strong>Domicilio:</strong> Calle Anatolio de Fuentes García 2, Polígono Costa Sur</li>
        <li><strong>Correo electrónico:</strong> informundolandia@gmail.com</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Datos que tratamos</h2>
      <p className="mb-4">
        Podemos tratar datos identificativos y de contacto de la persona adulta responsable, así como datos identificativos y de edad o fecha de nacimiento de menores cuando su registro resulte necesario para la organización de la actividad, acceso, seguridad o gestión de servicios vinculados al parque.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Finalidades del tratamiento</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li>Gestionar registros, consultas y solicitudes realizadas a través del sitio web.</li>
        <li>Identificar a la persona adulta responsable y, en su caso, a los menores asociados al servicio.</li>
        <li>Organizar el acceso a instalaciones, actividades, bonos y servicios relacionados.</li>
        <li>Atender incidencias, obligaciones de seguridad y requerimientos legales o administrativos.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Base jurídica</h2>
      <ul className="list-disc pl-5 mb-4 space-y-1">
        <li>Ejecución de la relación precontractual o contractual solicitada por la persona usuaria.</li>
        <li>Cumplimiento de obligaciones legales aplicables.</li>
        <li>Consentimiento, cuando proceda y sea solicitado de forma separada para finalidades no necesarias.</li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Conservación de los datos</h2>
      <p className="mb-4">
        Los datos se conservarán durante el tiempo necesario para cumplir la finalidad para la que fueron recabados y, posteriormente, durante los plazos legales de conservación, prescripción de responsabilidades o atención de reclamaciones que resulten aplicables.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Destinatarios</h2>
      <p className="mb-4">
        Con carácter general, no se comunicarán datos a terceros salvo obligación legal. No obstante, podrán acceder a los datos proveedores que presten servicios tecnológicos, de alojamiento, mantenimiento o soporte, actuando como encargados del tratamiento conforme al artículo 28 del RGPD.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Derechos</h2>
      <p className="mb-4">
        Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y, cuando proceda, portabilidad, mediante comunicación a <strong>informundolandia@gmail.com</strong>. También puedes presentar una reclamación ante la Agencia Española de Protección de Datos si consideras que el tratamiento no se ajusta a la normativa.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">8. Datos de menores</h2>
      <p className="mb-4">
        Los datos de menores se tratarán únicamente cuando resulten necesarios para la correcta organización, seguridad y prestación del servicio, y siempre vinculados a la persona adulta responsable que facilita el registro o la solicitud correspondiente.
      </p>
    </div>
  );
}
